module.exports = __webpack_public_path__ + "img/banner-recopick.483dc497.png";